import React, { Component } from 'react';
import find from 'lodash/find';

import * as type from 'store/actions/types';
import { SlateDialog } from 'components/Shared/SlateDialog';
import { ErrorDialogContent } from './ErrorDialogContent';

export class ErrorDialog extends Component {
  constructor(props) {
    super();
    this.state = {
      isOpen: false,
      currentDialog: '',
    };
  }

  handleClose = () => {
    this.props.dispatch({ type: type.ERROR_DIALOG_CLOSE });
  };

  render() {
    var dialogs = this.props.dialogs;
    var t = this.props.t;
    var errorDialog = find(dialogs, { type: 'errorDialog' });

    return (
      <SlateDialog
        open={errorDialog.isOpen}
        onClose={this.handleClose}
        title={t('errorDialog:somethingWentWrong')}
        maxWidth="xs"
        actions={[
          {
            label: t('btn:dismiss'),
            onClick: this.handleClose,
            variant: 'secondary',
            key: 'dismiss',
          },
        ]}
      >
        <ErrorDialogContent
          handleClose={this.handleClose}
          item={errorDialog}
          t={t}
        />
      </SlateDialog>
    );
  }
}
